import { render } from "./ButtonLearnMore.vue?vue&type=template&id=90dafe2a"
import script from "./ButtonLearnMore.vue?vue&type=script&lang=js"
export * from "./ButtonLearnMore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__